export default __webpack_public_path__ + "static/media/2204.cbe69940.png";